/** Design space for guest card (aligned with card-editor-engine page size). */
export const GUEST_CARD_DESIGN_W = 500;
export const GUEST_CARD_DESIGN_H = 700;
